import { render, staticRenderFns } from "./auto-message-template-settings.vue?vue&type=template&id=2466c765&scoped=true&"
import script from "./auto-message-template-settings.vue?vue&type=script&lang=js&"
export * from "./auto-message-template-settings.vue?vue&type=script&lang=js&"
import style0 from "./auto-message-template-settings.vue?vue&type=style&index=0&id=2466c765&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2466c765",
  null
  
)

export default component.exports